import React, { ReactNode } from "react";
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from "@nextui-org/react";

interface IDeleteModalProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  confirmationText?: string;
  warningMessage: ReactNode;
  title?: string;
  isLoading?: boolean;
  confirmationButtonColor?: "primary" | "success" | "warning" | "danger";
}

export const ConfirmationModal: React.FC<IDeleteModalProps> = ({
  isOpen,
  onOpenChange,
  onConfirm,
  warningMessage,
  confirmationText,
  title,
  isLoading,
  confirmationButtonColor,
}) => {
  return (
    <Modal isOpen={isOpen} backdrop="opaque" onOpenChange={onOpenChange}>
      <ModalContent>
        {(onClose) => (
          <>
            <ModalHeader className="flex flex-col gap-1">
              {title ? title : "Delete"}
            </ModalHeader>
            <ModalBody>
              <p>{warningMessage}</p>
            </ModalBody>
            <ModalFooter>
              <Button color="primary" variant="light" onPress={onClose}>
                Close
              </Button>
              <Button
                isLoading={isLoading}
                color={confirmationButtonColor || "danger"}
                onPress={() => {
                  onClose();
                  onConfirm();
                }}
              >
                {confirmationText || "Delete"}
              </Button>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  );
};
